export const STATUS_ACCOUNT_ACTIVE = 'ACTIVE';
export const STATUS_ACCOUNT_KYC_FAILED = 'KYC_FAILED';
export const STATUS_ACCOUNT_SUSPENDED = 'SUSPENDED';

export const STATUS_KYC_NOT_READY = 'NOT_READY';
export const STATUS_KYC_REJECT = 'REJECT';
export const STATUS_KYC_FAILED = 'FAILED';
export const STATUS_KYC_ERROR = 'ERROR';
export const STATUS_KYC_VERIFIED = 'VERIFIED';
export const STATUS_KYC_IN_PROCESS = 'IN_PROCESS';
export const STATUS_KYC_READY_FOR_DOWNLOAD = 'READY_FOR_DOWNLOAD';
export const STATUS_KYC_READY_TO_PROCESS = 'READY_TO_PROCESS';
export const STATUS_KYC_READY_TO_REVIEW = 'READY_TO_REVIEW';
export const STATUS_KYC_DOWNLOADED = 'DOWNLOADED';

export const COIN_STATUS = {
  inActive: 'INACTIVE',
  inProgress: 'IN_PROGRESS',
  reject: 'REJECT',
  active: 'ACTIVE',
};

export const SELFIE_STATUS = {
  isExist: 'EXIST',
  isNotExist: 'NOT_EXIST',
};
export const STATUS_MT_ACTIVE = 'ACTIVE';
export const STATUS_MT_REJECTED = 'REJECTED';
export const STATUS_MT_INACTIVE = 'IN_ACTIVE';
export const STATUS_MT_IN_PROCESS = 'IN_PROCESS';

export const STATUS_PREMIUM_INACTIVE = 'IN_ACTIVE';
